import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import pkiApi, { CertExpirationDto } from 'src/api/auth/pkiApi';
import { RootState } from 'src/store';

// # types
export type CertExpirationEntity = CertExpirationDto;

interface CertExpirationState {
  initialized: boolean;
  // checked: boolean;
  entity: CertExpirationEntity;
}

// # initial state
const initialState: CertExpirationState = {
  initialized: false,
  // checked: false,
  entity: {
    certExpirationAlertDays: 0,
    certs: [],
  },
};

// # thunks
export const thunkLoadCertExpiration = createAsyncThunk('pki/policy/expiration', async () => {
  return await pkiApi.expiredCerts();
});

const pkiSlice = createSlice({
  name: 'pki',
  initialState,
  reducers: {
    // pikChecked: (state) => {
    //   state.checked = true;
    // },
    // pikInitChecked: (state) => {
    //   state.checked = false;
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(thunkLoadCertExpiration.fulfilled, (state, { payload: certs }) => {
      state.entity = certs;
      state.initialized = true;
    });
  },
});

// # selectors
// export const selectChecked = (state: RootState): boolean => {
//   return state.pki.checked;
// };
export const selectInitialized = (state: RootState): boolean => {
  return state.pki.initialized;
};
export const selectCertExpirationEntity = (state: RootState): CertExpirationEntity =>
  state.pki.entity;

// export const { pikChecked, pikInitChecked } = pkiSlice.actions;
export default pkiSlice.reducer;
